export type MatchListOption = {
  id: string;
  label: string;
  description?: string;
  previewImageUrl?: string | null;
  unavailable?: boolean;
};

export const MOCK_PRODUCT_OPTIONS: MatchListOption[] = [
  { id: 'prod-1', label: 'Running Shoes', description: 'SKU-1001' },
  { id: 'prod-2', label: 'Wireless Headphones', description: 'SKU-2044' },
  { id: 'prod-3', label: 'Yoga Mat', description: 'SKU-3310' },
  { id: 'prod-4', label: 'Water Bottle', description: 'SKU-4412' },
  { id: 'prod-5', label: 'Gym Bag', description: 'SKU-5520' },
];

export const MOCK_LOCATION_OPTIONS: MatchListOption[] = [
  { id: 'loc-sp', label: 'São Paulo', description: 'SP, Brazil' },
  { id: 'loc-rj', label: 'Rio de Janeiro', description: 'RJ, Brazil' },
  { id: 'loc-mg', label: 'Belo Horizonte', description: 'MG, Brazil' },
  { id: 'loc-rs', label: 'Porto Alegre', description: 'RS, Brazil' },
  { id: 'loc-pr', label: 'Curitiba', description: 'PR, Brazil' },
];

export const MOCK_RFM_GROUP_OPTIONS: MatchListOption[] = [
  { id: 'champions', label: 'Champions' },
  { id: 'loyal', label: 'Loyal Customers' },
  { id: 'potential', label: 'Potential Loyalists' },
  { id: 'new', label: 'New Customers' },
  { id: 'promising', label: 'Promising' },
  { id: 'needAttention', label: 'Need Attention' },
  { id: 'aboutToSleep', label: 'About to Sleep' },
  { id: 'at-risk', label: 'At Risk' },
  { id: 'cannot-lose', label: 'Cannot Lose Them' },
  { id: 'hibernating', label: 'Hibernating' },
  { id: 'lost', label: 'Lost' },
];
